import {
  getUnifiedString,
} from "@vsimple/vsimple-ui"
import type { VProfileStatusProp } from "@vsimple/vsimple-ui"

type UserAccount = {
  id: string | number
  firstName: string
  lastName: string
  email: string
  avatar: string | null
  jobTitle?: string | null
  isActive: boolean
  // The profile status ({ name, expiresAt }) or null
  status: VProfileStatusProp
}

type CompanyAccount = {
  id: string | number
}

type UserResponseItem = {
  account: UserAccount
  companyAccount: CompanyAccount
  tags: unknown[]
}

export type MappedUser = {
  accountIdValue: string
  value: string
  label: string
  status: VProfileStatusProp
  avatar: string | null
  email: string
  firstName: string
  lastName: string
  jobTitle: string | null
  initials: string
  isActive: boolean
}

export default function userResponseMapper(response: UserResponseItem[]): MappedUser[] {

  return response.map((user) => {
    return {
      ...user.account,
      ...user.companyAccount,
      id: user.account.id,
      accountId: user.companyAccount.id,
      tags: user.tags,
    }
  }).filter((user) => Object.keys(user).length).map((user) => {
    return {
      accountIdValue: String(user.accountId),
      value: String(user.id),
      label: getUnifiedString([user.firstName, user.lastName]),
      status: user.status,
      avatar: user.avatar,
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      jobTitle: user.jobTitle || null,
      initials: String(user.firstName)[0].toUpperCase() + String(user.lastName)[0].toUpperCase(),
      isActive: user.isActive,
    }
  })
}
